<template>
  <IQOS required class="gap-row-xs" v-if="missingDishes.length">
    <template #title>
      <p class="orange-4-color iqos-icon-align">
        <BaseIcon icon="allert-regular" size="sm" />
        {{ $t("poster_missing_dishes.title") }}
      </p>
    </template>

    <p class="qrw-paragraph-md iqos-comment v1-grey-10-color">
      {{ $t("poster_missing_dishes.text") }} ({{ missingDishes.length }})
    </p>

    <BaseButton @click="onView" variant="secondary" size="md" color="v1-grey-10">
      {{ $t("poster_missing_dishes.view") }}
    </BaseButton>
  </IQOS>
</template>

<script>
export default {
  props: {
    menu: Object,
  },
  methods: {
      onView() {
          const first = this.missingDishes[0];

          this.$router.push({
              name: 'menu',
              params: {
                  id: this.menu._id
              },
              query: {
                  product_id: first._id,
                  category_id: first.category_id
              }
          });

          this.$emit('showEditor');
      }
  },
  computed: {
    missingDishes() {
      return this.menu.products.filter((product) => {
        return (
          product.name && product.category_id &&
          !product.poster_product_id &&
          !product.price_groups
            .filter((pg) => pg.single_select || pg.min_count)
            .some((pg) => {
              return pg.items.some(
                (pgi) =>
                  pgi.poster_product_id ||
                  pgi.poster_modification_id ||
                  pgi.poster_modificator_id
              );
            })
        );
      });
    },
  },
};
</script>

<style>
</style>